(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[812],{

/***/ 6466:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organisation]/[shopId]/order/shopping-cart",
      function () {
        return __webpack_require__(831);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1748);



function Image(props) {
    let { url , alt , sizes , className , style , width =400 , height , fitMode =_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .ImageFitMode.Clip */ .B.Clip  } = props;
    let srcset = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>{
        return [
            0.5,
            1,
            2
        ].map((multiplier)=>{
            if (!url) return "";
            let calculatedWidth = width * multiplier;
            let calculatedHeight = height ? height * multiplier : undefined;
            return "".concat((0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, calculatedWidth, calculatedHeight, fitMode), " ").concat(calculatedWidth, "w");
        }).join(",");
    }, [
        url
    ]);
    let fallback = url ? (0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, width, height) : "#";
    return fallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        srcSet: srcset,
        sizes: sizes,
        src: fallback,
        alt: alt,
        title: alt,
        className: className,
        style: style
    }) : null;
}


/***/ }),

/***/ 2043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TextField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _react_aria_textfield__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3306);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const TextField = (props)=>{
    let { label , error , onSubmit  } = props;
    let ref = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    const handleKeyDown = react__WEBPACK_IMPORTED_MODULE_2__.useCallback((e)=>{
        if ((e === null || e === void 0 ? void 0 : e.key) === "Enter") {
            if (ref && ref.current) {
                ref.current.blur();
            }
            if (onSubmit) {
                onSubmit();
            }
        }
    }, [
        onSubmit
    ]);
    let { labelProps , inputProps  } = (0,_react_aria_textfield__WEBPACK_IMPORTED_MODULE_3__/* .useTextField */ .E)({
        ...props,
        onKeyDown: handleKeyDown
    }, ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                ...labelProps,
                className: "font-medium text-gray-700",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ...inputProps,
                ref: ref,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("border w-full p-2 rounded", {
                    "border-red-400": !!error,
                    "border-gray-300": !error
                })
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "my-1 text-red-600 text-sm font-medium",
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 9922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ OrderHint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(499);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5075);






const OrderHint = ()=>{
    let { order , organisation  } = (0,_contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__/* .useApplicationState */ .jm)();
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    if ((order === null || order === void 0 ? void 0 : order.status) !== _generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .OrderStatusEnumType.Created */ .GQ.Created) {
        return null;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-screen-xl mx-auto py-4",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(order.shopId, "/order/overview"),
                    className: "block w-full px-2 py-2 rounded border bg-brand-600 text-white mb-8 text-center font-medium",
                    children: translate("order.openOrderLink")
                })
            })
        });
    }
};


/***/ }),

/***/ 831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@translator-app/react/lib/index.js
var lib = __webpack_require__(1477);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(6808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/atoms/button/index.tsx + 4 modules
var atoms_button = __webpack_require__(7997);
// EXTERNAL MODULE: ./utils/error.ts
var utils_error = __webpack_require__(7524);
;// CONCATENATED MODULE: ./components/atoms/error-text.tsx



const ErrorText = (props)=>{
    const { error  } = props;
    const errorText = (0,utils_error/* getErrorMessageFromError */.d)(error);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "font-medium my-4 text-red-600",
        children: errorText
    });
};

// EXTERNAL MODULE: ./components/atoms/heading.tsx
var heading = __webpack_require__(2061);
// EXTERNAL MODULE: ./components/atoms/image.tsx
var atoms_image = __webpack_require__(2881);
// EXTERNAL MODULE: ./components/atoms/link.tsx
var atoms_link = __webpack_require__(9235);
// EXTERNAL MODULE: ./components/atoms/textfield.tsx
var textfield = __webpack_require__(2043);
// EXTERNAL MODULE: ./components/organisms/error-boundary.tsx
var error_boundary = __webpack_require__(3570);
// EXTERNAL MODULE: ./components/organisms/not-found.tsx
var not_found = __webpack_require__(1425);
// EXTERNAL MODULE: ./components/organisms/order-buttons.tsx
var order_buttons = __webpack_require__(8571);
// EXTERNAL MODULE: ./components/organisms/order-hint.tsx
var order_hint = __webpack_require__(9922);
// EXTERNAL MODULE: ./components/organisms/order-layout.tsx
var order_layout = __webpack_require__(2461);
// EXTERNAL MODULE: ./components/templates/fallback-page-template.tsx
var fallback_page_template = __webpack_require__(9169);
// EXTERNAL MODULE: ./components/templates/page-template.tsx + 1 modules
var page_template = __webpack_require__(3900);
// EXTERNAL MODULE: ./components/templates/shop-page-template.tsx + 4 modules
var shop_page_template = __webpack_require__(6781);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
// EXTERNAL MODULE: ./contexts/application-state-context.tsx
var application_state_context = __webpack_require__(499);
// EXTERNAL MODULE: ./contexts/language-context.tsx + 4 modules
var language_context = __webpack_require__(5262);
// EXTERNAL MODULE: ./generated/graphql.tsx
var graphql = __webpack_require__(5075);
;// CONCATENATED MODULE: ./icons/x.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  d: "M18 6L6 18M6 6l12 12"
});

var SvgX = function SvgX(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref);
};

/* harmony default export */ var x = (SvgX);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(958);
// EXTERNAL MODULE: ./utils/currency.ts
var currency = __webpack_require__(8734);
// EXTERNAL MODULE: ./utils/date-time.ts
var date_time = __webpack_require__(7008);
// EXTERNAL MODULE: ./node_modules/isemail/lib/index.js
var isemail_lib = __webpack_require__(2196);
;// CONCATENATED MODULE: ./utils/email.ts

function isValidEmail(emailValue) {
    return isemail_lib.validate(emailValue, {
        minDomainAtoms: 2
    });
}

// EXTERNAL MODULE: ./utils/invariant.ts
var invariant = __webpack_require__(8793);
// EXTERNAL MODULE: ./utils/product.ts
var product = __webpack_require__(996);
;// CONCATENATED MODULE: ./utils/shopping-cart.ts

function totalFromCart(cart) {
    return cart.reduce((acc, item)=>{
        return acc + (0,product/* getReservationPrices */.tF)(item).totalPriceWithDiscount;
    }, 0);
}

// EXTERNAL MODULE: ./pages/_app.tsx + 70 modules
var _app = __webpack_require__(7479);
;// CONCATENATED MODULE: ./pages/[organisation]/[shopId]/order/shopping-cart.tsx



































const LOCALSTORAGE_KEY = "saved-contact-information";
function ShoppingCartItemComponent(props) {
    let { item , organisation  } = props;
    let router = (0,next_router.useRouter)();
    let { removeFromCart , shopId  } = (0,application_state_context/* useApplicationState */.jm)();
    let name = react.useMemo(()=>{
        return (0,product/* getReservationProductsName */.nd)(item);
    }, [
        item
    ]);
    let images = react.useMemo(()=>{
        return (0,product/* getReservationProductImages */.iK)(item);
    }, [
        item
    ]);
    let productLink = "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(shopId, "/product/").concat(item._id);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            !!images.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-1/4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: productLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_image/* Image */.E, {
                        url: images[0],
                        width: 150,
                        sizes: "150px",
                        alt: name,
                        className: "w-full h-auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("pl-4", {
                    "w-3/4": !!images.length,
                    "w-full": !images.length
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gray-700 text-lg font-medium whitespace-pre-wrap break-words uppercase",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: productLink,
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* Button */.z, {
                                    isIcon: true,
                                    appearance: "subtle",
                                    onPress: ()=>{
                                        removeFromCart([
                                            item
                                        ]);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {
                                        className: "w-4 h-4"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-between items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xl font-bold text-gray-700",
                            children: (0,currency/* formatCurrency */.x)((0,product/* getReservationPrices */.tF)(item).totalPriceWithDiscount)
                        })
                    })
                ]
            })
        ]
    });
}
function PageContent(props) {
    let { shop  } = props;
    let { shoppingCart , organisation , shopId  } = (0,application_state_context/* useApplicationState */.jm)();
    let router = (0,next_router.useRouter)();
    let { language  } = (0,language_context/* useLanguageContext */.Q)();
    let { translate  } = (0,lib.useTranslator)();
    let [isLoading, setIsLoading] = react.useState(false);
    let [serverError, setServerError] = react.useState(null);
    let [formValues, setFormValues] = react.useState({
        firstName: "",
        lastName: "",
        email: ""
    });
    let [errors, setErrors] = react.useState({
        firstName: "",
        lastName: "",
        email: ""
    });
    let isEmpty = !shoppingCart.length;
    let pickupDateTime = react.useMemo(()=>{
        return dayjs_min_default()(Date.now()).add(shop.vendingPickupTime, "hour");
    }, [
        shop
    ]);
    const totalPrice = react.useMemo(()=>{
        return totalFromCart(shoppingCart);
    }, [
        shoppingCart
    ]);
    react.useEffect(()=>{
        if (true) {
            try {
                const foundItem = (0,invariant/* nullthrows */.W)(localStorage.getItem(LOCALSTORAGE_KEY), "No locally stored value");
                const savedContactInformation = JSON.parse(foundItem);
                if (savedContactInformation.version === constants/* APPLICATION_VERSION */.aj) {
                    let { firstName , lastName , email  } = savedContactInformation.values;
                    setFormValues({
                        firstName,
                        lastName,
                        email
                    });
                } else {
                    localStorage.removeItem(LOCALSTORAGE_KEY);
                }
            } catch (err) {
            // do nothing...
            }
        }
    }, [
        "object"
    ]);
    const handleFormValueChange = (field)=>{
        return (newValue)=>{
            let valuesClone = {
                ...formValues
            };
            valuesClone[field] = newValue;
            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify({
                version: constants/* APPLICATION_VERSION */.aj,
                values: valuesClone
            }));
            setFormValues(valuesClone);
        };
    };
    const handlePlaceOrder = async ()=>{
        setIsLoading(true);
        try {
            let errors = {};
            if (!formValues.firstName) {
                errors.firstName = translate("shoppingCart.validation.firstNameRequired");
            }
            if (!formValues.lastName) {
                errors.lastName = translate("shoppingCart.validation.lastNameRequired");
            }
            if (!isValidEmail(formValues.email)) {
                errors.email = translate("shoppingCart.validation.emailInvalid");
            }
            setErrors(errors);
            if (Object.keys(errors).length) {
                setIsLoading(false);
                return;
            }
            let orderData = await (0,api/* createOrder */.LV)({
                shopId,
                language: graphql/* LanguageEnum.Nl */.Go.Nl,
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                email: formValues.email,
                items: shoppingCart.map((i)=>i._id),
                organisationId: organisation._id
            });
            js_cookie_default().set((0,api/* getLastOrderCookieName */._n)(organisation.pathname), {
                version: constants/* APPLICATION_VERSION */.aj,
                orderId: orderData._id,
                orderToken: orderData.orderToken
            }, {
                // Expire in 2 days
                expires: 2,
                secure: constants/* IS_PRODUCTION */.Mw,
                sameSite: constants/* IS_PRODUCTION */.Mw ? "None" : undefined
            });
            window.location.href = "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(shopId, "/order/overview");
        } catch (err) {
            (0,_app.captureException)(err);
            setServerError(err);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100 pb-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white p-8 max-w-lg mx-auto shadow-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                    children: translate("shoppingCart.yourCart")
                }),
                !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-medium text-gray-600 mt-2",
                    children: translate("order.pickupAtDeadline", {
                        pickupDateTime: (0,date_time/* formatDateTimeString */.I)(pickupDateTime, language)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-8 max-w-lg w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(order_layout/* OrderLayout */.B, {
                            totalPrice: totalPrice,
                            children: !isEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: shoppingCart.map((item)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartItemComponent, {
                                        item: item,
                                        organisation: organisation
                                    }, item._id);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "font-medium text-center my-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-600",
                                        children: translate("shoppingCart.empty")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* Link */.r, {
                                            href: "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(shopId),
                                            children: translate("products.viewOurAvailableProducts")
                                        })
                                    })
                                ]
                            })
                        }),
                        !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textfield/* TextField */.n, {
                                        label: translate("shoppingCart.firstName"),
                                        value: formValues.firstName,
                                        onChange: handleFormValueChange("firstName"),
                                        placeholder: "John",
                                        error: errors.firstName,
                                        isDisabled: isLoading
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textfield/* TextField */.n, {
                                        label: translate("shoppingCart.lastName"),
                                        value: formValues.lastName,
                                        onChange: handleFormValueChange("lastName"),
                                        placeholder: "Doe",
                                        error: errors.lastName,
                                        isDisabled: isLoading
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textfield/* TextField */.n, {
                                        label: translate("shoppingCart.email"),
                                        value: formValues.email,
                                        onChange: handleFormValueChange("email"),
                                        placeholder: "john@example.org",
                                        error: errors.email,
                                        isDisabled: isLoading
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                                    error: serverError
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(order_buttons/* OrderButtons */.g, {
                                    prevButtonText: translate("general.previous"),
                                    onPrevButtonPress: ()=>{
                                        router.push("/[organisation]/[shopId]", "/".concat(organisation.pathname, "/").concat(shopId));
                                    },
                                    nextButtonText: translate("general.next"),
                                    onNextButtonPress: handlePlaceOrder,
                                    nextButtonDisabled: !shoppingCart.length,
                                    isLoading: isLoading
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var __N_SSP = true;
function Index(props) {
    let { organisation , shop , shoppingCart , order , reservations , error  } = props;
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fallback_page_template/* FallbackPageTemplate */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(error_boundary/* ErrorFallback */.H, {
                error: error
            })
        });
    }
    if (!organisation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_template/* PageTemplate */.P, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found/* NotFound */.T, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shop_page_template/* ShopPageTemplate */.g, {
        organisation: organisation,
        shop: shop,
        reservations: reservations,
        shoppingCart: shoppingCart,
        order: order,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(order_hint/* OrderHint */.H, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
                ...props
            })
        ]
    });
}


/***/ }),

/***/ 7524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getErrorMessageFromError; }
/* harmony export */ });
function getErrorMessageFromError(err) {
    var ref;
    if (!err) {
        return "";
    }
    if (typeof err === "string") {
        return err;
    }
    let errorMessage = err.message;
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length) {
        errorMessage = err.graphQLErrors.map((e)=>e.message).join("\n");
    }
    if (Array.isArray((ref = err.response) === null || ref === void 0 ? void 0 : ref.errors) && err.response.errors.length) {
        errorMessage = err.response.errors.map((e)=>e.message).join("\n");
    }
    if (err.networkError && err.networkError.result && err.networkError.result.errors.length) {
        errorMessage = err.networkError.result.errors.map((e)=>e.message).join("\n");
    }
    return errorMessage;
}


/***/ }),

/***/ 8793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ nullthrows; }
/* harmony export */ });
/* unused harmony export invariant */
const prefix = "Invariant failed";
// Throw an error if the condition fails
// Strip out error messages for production
// > Not providing an inline default argument for message as the result is smaller
function invariant(condition, // Can provide a string, or a function that returns a string for cases where
// the message takes a fair amount of effort to compute
message) {
    if (condition) {
        return;
    }
    const provided = typeof message === "function" ? message() : message;
    // Options:
    // 1. message provided: `${prefix}: ${provided}`
    // 2. message not provided: prefix
    const value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}
function nullthrows(value, message) {
    invariant(value != null, message);
    return value;
}


/***/ }),

/***/ 7627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "uu": function() { return /* binding */ formatProductUnitAmount; }
/* harmony export */ });
/* unused harmony exports formatTemperature, formatPercentage */
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);

function formatAmount(value) {
    let unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2, enforceDecimals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    let formattedValue = Math.round(value * 10 ** decimals) / 10 ** decimals;
    if (enforceDecimals) {
        formattedValue = formattedValue.toFixed(decimals);
    } else {
        formattedValue = formattedValue.toString();
    }
    return "".concat(formattedValue.replace(".", ",")).concat(unit ? unit : "");
}
function formatTemperature(value) {
    return formatAmount(value, "\xb0C");
}
function formatPercentage(value) {
    return formatAmount(value * 100, "%");
}
function formatProductUnitAmount(amount, unitType) {
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit) {
        return "".concat(amount.toString(10), "x");
    }
    let value = amount;
    if (amount > 1000) {
        value = amount / 1000;
    }
    let suffix = "";
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Liter */ .Rx.Liter) {
        suffix = amount > 1000 ? "l" : "cl";
    } else {
        suffix = amount > 1000 ? "kg" : "g";
    }
    return formatAmount(value, suffix, 2, amount > 1000);
}


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ getProductCollectionItemsSummary; },
/* harmony export */   "T7": function() { return /* binding */ getLocalisedString; },
/* harmony export */   "iK": function() { return /* binding */ getReservationProductImages; },
/* harmony export */   "nd": function() { return /* binding */ getReservationProductsName; },
/* harmony export */   "tF": function() { return /* binding */ getReservationPrices; }
/* harmony export */ });
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);
/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7627);


function getLocalisedString(value) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    var ref;
    let foundValue = value.find((i)=>i.language === language);
    return foundValue ? foundValue.value : ((ref = value[0]) === null || ref === void 0 ? void 0 : ref.value) || "";
}
function getReservationProductsName(reservation) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    let nameValues = reservation.vendingProducts.filter((p)=>{
        var ref;
        return !!(p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.name);
    }).map((p)=>{
        var ref;
        var ref1;
        return "".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    });
    return "".concat(nameValues.slice(0, 2).join(", ")).concat(nameValues.length > 2 ? ", ..." : "");
}
function getReservationProductImages(reservation) {
    let newImages = [];
    for (let vendingProduct of reservation.vendingProducts){
        var ref;
        if (vendingProduct === null || vendingProduct === void 0 ? void 0 : (ref = vendingProduct.product) === null || ref === void 0 ? void 0 : ref.imageUrl) {
            var ref1, ref2;
            newImages.push(vendingProduct.product.imageUrl);
            if ((ref1 = vendingProduct.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.includedProducts) === null || ref2 === void 0 ? void 0 : ref2.length) {
                for (let includedProduct of vendingProduct.product.includedProducts){
                    var ref3;
                    if (includedProduct === null || includedProduct === void 0 ? void 0 : (ref3 = includedProduct.product) === null || ref3 === void 0 ? void 0 : ref3.imageUrl) {
                        newImages.push(includedProduct.product.imageUrl);
                    }
                }
            }
        }
    }
    return newImages.filter((img)=>!!img);
}
function getProductCollectionItemsSummary(products) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    return products.filter((p)=>{
        var ref;
        return !!((p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) && (p === null || p === void 0 ? void 0 : p.amount));
    }).map((p)=>{
        var ref;
        var ref1;
        return "- ".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    }).join("\n");
}
function getReservationPrices(reservation) {
    var _vendingTotalPrice;
    const vendingTotalPrice = (_vendingTotalPrice = reservation.vendingTotalPrice) !== null && _vendingTotalPrice !== void 0 ? _vendingTotalPrice : 0;
    const vendingDiscount = reservation.vendingDiscount ? reservation.vendingDiscount / 10000 : 0;
    const discountAmount = vendingTotalPrice * vendingDiscount;
    const totalPriceWithDiscount = vendingTotalPrice - discountAmount;
    var _vendingTotalPrice1;
    return {
        discountAmount,
        totalPriceWithDiscount,
        totalPrice: (_vendingTotalPrice1 = reservation.vendingTotalPrice) !== null && _vendingTotalPrice1 !== void 0 ? _vendingTotalPrice1 : 0
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,444,207,972,960,239,774,888,179], function() { return __webpack_exec__(6466); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);